import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BaseRequestOptions, HttpModule } from '@angular/http';
import { MockBackend } from '@angular/http/testing';

import { AuthRoutingModule } from './auth-routing.routing';
import { AuthComponent } from './auth.component';
import { forgotComponent } from './forgot.component';
import { AlertComponent } from './_directives/alert.component';
import { LogoutComponent } from './logout/logout.component';
import { AuthGuard } from './_guards/auth.guard';
import { AlertService } from './_services/alert.service';
import { AuthenticationService } from './_services/authentication.service';
import { UserService } from './_services/user.service';
import { webConfig } from '../webConfig';
import { ResetPasswordOnceComponent } from './resetpasswordOnce.component';

@NgModule({
    declarations: [
        AuthComponent,
        forgotComponent,
        ResetPasswordOnceComponent,
        AlertComponent,
        LogoutComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        HttpModule,
        AuthRoutingModule,
    ],
    providers: [
        AuthGuard,
        AlertService,
        AuthenticationService,
        UserService,
        MockBackend,
        BaseRequestOptions,
        webConfig,
    ],
    entryComponents: [AlertComponent],
})

export class AuthModule {
}


// WEBPACK FOOTER //
// D:/FMFB/FMFB Dashboard/src/app/auth/auth.module.ts